var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 96,
    viewBox: "0 0 89 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.463 2L46.6536 2.01166C45.478 2.00984 44.3135 2.24093 43.2266 2.69176C42.1398 3.14259 41.1519 3.80431 40.3193 4.63915C39.4867 5.474 38.8258 6.4656 38.3742 7.55736C37.9226 8.64912 37.6893 9.81964 37.6875 11.0021V27.6462",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3984 50.4141C42.9278 51.5265 44.7678 52.1238 46.6552 52.1205H63.4527V60.3125L74.1006 52.1205H78.6944C81.0687 52.1242 83.3473 51.179 85.0287 49.4929C86.7102 47.8068 87.6569 45.5179 87.6605 43.1298V11.0041C87.6587 9.82167 87.4254 8.65114 86.9738 7.55938C86.5222 6.46763 85.8613 5.47602 85.0287 4.64118C84.1961 3.80634 83.2082 3.14461 82.1214 2.69378C81.0345 2.24296 79.87 2.01186 78.6944 2.01368H74.6441",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7656 38.9415L56.6903 39.6939C58.1554 40.8867 59.9832 41.5374 61.868 41.5374H74.9873C75.2835 41.5374 75.5767 41.4769 75.849 41.3596C76.1214 41.2423 76.3672 41.0706 76.5716 40.8549C76.7759 40.6391 76.9347 40.3839 77.0381 40.1047C77.1415 39.8255 77.1874 39.528 77.1732 39.2304C77.118 38.0466 77.1758 27.2654 77.1758 26.0499C77.1758 25.4662 76.9452 24.9063 76.5348 24.4935C76.1244 24.0807 75.5678 23.8488 74.9874 23.8488L66.091 23.8218L67.1796 21.2273C67.7381 19.8973 67.984 18.4556 67.8983 17.0144C67.8127 15.5732 67.3976 14.1712 66.6855 12.9176C66.5887 12.7472 66.4588 12.598 66.3035 12.4791C66.1482 12.3601 65.9707 12.2738 65.7816 12.2252C65.5924 12.1766 65.3955 12.1668 65.2025 12.1963C65.0096 12.2258 64.8244 12.294 64.6582 12.3969C64.4464 12.528 64.2716 12.7115 64.1503 12.9298C64.029 13.1481 63.9653 13.3941 63.9654 13.6442C63.9653 15.9709 63.1206 18.2176 61.5899 19.9623L55.9174 26.4183",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5954 40.9265H48.1719V24.127H55.5954V40.9265Z",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 45.4146V59.4224C2.00143 60.3549 2.18546 61.2779 2.54157 62.1389C2.89768 62.9998 3.41891 63.7818 4.07549 64.4401C4.73207 65.0985 5.51114 65.6203 6.36823 65.9758C7.22532 66.3313 8.14364 66.5136 9.07075 66.5121H22.951V73.0328L31.3478 66.5121",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1968 61.1459C41.3372 60.5819 41.408 60.0026 41.4076 59.4212V34.0873C41.4048 32.2041 40.6583 30.3991 39.3324 29.0695C38.0065 27.7398 36.2097 26.9944 34.3374 26.9971H9.07116C8.144 26.9956 7.22563 27.1778 6.36849 27.5333C5.51134 27.8888 4.73221 28.4106 4.07559 29.069C3.41896 29.7273 2.8977 30.5094 2.54157 31.3703C2.18544 32.2313 2.00141 33.1545 2 34.087V46.3851",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 44.0635H30.9685",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 50.2261H30.9685",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2984 37.8262L23.2344 56.4645",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1655 37.8262L17.1016 56.4645",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1056 73.1781V66.3633C60.1046 65.7016 59.974 65.0465 59.7213 64.4355C59.4686 63.8246 59.0987 63.2696 58.6328 62.8024C58.1668 62.3352 57.614 61.9649 57.0057 61.7126C56.3975 61.4603 55.7458 61.331 55.0879 61.332H37.1582C35.8295 61.33 34.5544 61.8589 33.6134 62.8025C32.6725 63.746 32.1427 65.0269 32.1406 66.3633V84.3418C32.1427 85.6782 32.6725 86.9591 33.6134 87.9026C34.5544 88.8462 35.8295 89.3751 37.1582 89.3731H47.0078V94.0005L52.9667 89.3731H55.0877C55.7457 89.3741 56.3974 89.2448 57.0056 88.9925C57.6139 88.7402 58.1668 88.3699 58.6327 87.9027C59.0987 87.4355 59.4686 86.8806 59.7213 86.2696C59.974 85.6586 60.1046 85.0036 60.1056 84.3418V72.0213",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.128 81.4632C50.4425 79.1627 52.6779 77.2053 52.6779 74.1727C52.6779 69.99 47.5837 68.9442 46.128 72.0814C44.4645 68.8396 39.5781 69.99 39.5781 74.1727C39.5781 77.2053 41.8134 79.1627 46.128 81.4632Z",
    stroke: "#20ACE3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.b9b96c14b5ba8461485972623d1f8f36.svg";
export { ForwardRef as ReactComponent };